import type { LocationDatapoint } from "@strtmn/j1939"
import { FaSignal } from "react-icons/fa6"
import { TbActivity, TbEngine, TbLayoutBottombar } from "react-icons/tb"
import {
  BatteriePrimusIcon,
  ClockFettIcon,
  DefLevelIcon,
  DieselLevelIcon,
  GaugeSolidIcon,
  TruckFastSolidIcon,
  HydraulicOilTemperatureIcon,
  KuehlwasserTemperaturIcon,
  MixerSpeedIcon,
} from "../icons"
import {
  ConnectivityWidget,
  DashboardColumn,
  DashboardColumns,
  DashboardGroup,
  TelemetryNumberWidget,
  TelemetryPercentageWidget,
  type VehicleDashboardProps,
} from "./DashboardUtils"
import * as W from "./Widgets"

export function DieselPrimusDashboard({
  vehicleStatus,
}: VehicleDashboardProps) {
  const telemetry = vehicleStatus.Telemetry

  const location = telemetry["Location"] as unknown as LocationDatapoint
  const hasLocation =
    location &&
    location.Latitude &&
    location.Latitude !== 0 &&
    location.Longitude &&
    location.Longitude !== 0

  // console.debug("telemetry =", telemetry)
  // console.debug(telemetry["Location"])

  return (
    <DashboardColumns>
      <DashboardColumn>
        <DashboardGroup title="Motor & Hydraulik" IconNode={<TbEngine />}>
          {/* Motordrehzahl */}
          <TelemetryNumberWidget
            title="Motordrehzahl"
            IconNode={<GaugeSolidIcon />}
            defaultUnit="1/min"
            precision={0}
            data={telemetry}
            keys={[
              `${0xf004}@${0x0000}/DiesAktDrehz`,
              `${0xf004}@${0x0000}/nEngAct`,
              // `${0xff79}@${0x0032}/DiesAktDrehz`,
            ]}
          />
          {/* Schnecken-Drehzahl */}
          <TelemetryNumberWidget
            title="Schnecken-Drehzahl"
            IconNode={<MixerSpeedIcon />}
            defaultUnit="1/min"
            precision={0}
            data={telemetry}
            keys={[`${0xff7b}@${0x0032}/MischDrehzAkt`]}
          />
          {/* Hydrauliköltemperatur */}
          <TelemetryNumberWidget
            title="Hydrauliköltemperatur"
            IconNode={<HydraulicOilTemperatureIcon />}
            defaultUnit="°C"
            precision={0}
            data={telemetry}
            keys={[`${0xff79}@${0x0032}/HyOelTemp`]}
          />
          {/* Kühlmitteltemperatur */}
          <TelemetryNumberWidget
            title="Kühlmitteltemperatur"
            IconNode={<KuehlwasserTemperaturIcon />}
            defaultUnit="°C"
            precision={0}
            data={telemetry}
            keys={[
              `${0xfeee}@${0x0000}/DiesTmpKuehlm`,
              `${0xfeee}@${0x0000}/tEngCoolt`,
            ]}
          />
          {/* Batteriespannung */}
          <TelemetryNumberWidget
            title="Batteriespannung"
            IconNode={<BatteriePrimusIcon />}
            defaultUnit="V"
            factor={0.1} // Faktor 0.1: 238 -> 23.8V
            precision={1}
            data={telemetry}
            keys={[`${0xff8a}@${0x0032}/BattSp30`]}
          />
        </DashboardGroup>
      </DashboardColumn>

      <DashboardColumn>
        <DashboardGroup title="Füllstände" IconNode={<TbLayoutBottombar />}>
          {/* Dieselfüllstand */}
          <TelemetryPercentageWidget
            title="Dieselfüllstand"
            IconNode={<DieselLevelIcon />}
            precision={0}
            data={telemetry}
            keys={[`${0xff79}@${0x0032}/DiesLvl`]}
          />
          {/* AdBlue-Füllstand */}
          <TelemetryPercentageWidget
            title="AdBlue-Füllstand"
            IconNode={<DefLevelIcon />}
            precision={0}
            data={telemetry}
            keys={[
              `${0xfe56}@${0x0000}/DiesDefLvl`,
              // `${0xff79}@${0x0032}/DiesDefLvl`,
            ]}
          />
        </DashboardGroup>
      </DashboardColumn>

      <DashboardColumn>
        <DashboardGroup title="Betrieb" IconNode={<TbActivity />}>
          {/* Betriebsstunden */}
          <TelemetryNumberWidget
            title="Betriebsstunden"
            IconNode={<ClockFettIcon />}
            defaultUnit="h"
            precision={0}
            data={telemetry}
            keys={[
              `${0xfee5}@${0x0000}/DiesBetrStd`,
              // `${0xff82}@${0x0032}/DiesBetrStd`,
            ]}
          />
          {/* Fahrgeschwindigkeit */}
          <TelemetryNumberWidget
            title="Fahrgeschwindigkeit"
            IconNode={<TruckFastSolidIcon />}
            defaultUnit="km/h"
            precision={0}
            data={telemetry}
            keys={[
              `${0xfef1}@${0x0003}/FahrGeschw`,
              `${0xfef1}@${0x0003}/vWhlBasdVehSpd`,
              // `${0xff78}@${0x0032}/FahrGeschw`,
            ]}
          />
        </DashboardGroup>
      </DashboardColumn>

      <DashboardColumn>
        <DashboardGroup title="Verbindung" IconNode={<FaSignal />}>
          {/* Datenverbindung */}
          <ConnectivityWidget data={telemetry} />

          {hasLocation ? (
            <W.MapWidget
              title="Standort"
              location={telemetry["Location"] as unknown as LocationDatapoint}
            />
          ) : null}
        </DashboardGroup>
      </DashboardColumn>
    </DashboardColumns>
  )
}
